'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _components = require('../../components');

var _Home = require('./Home.css');

var _Home2 = _interopRequireDefault(_Home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Home = (_dec = (0, _reactCssModules2.default)(_Home2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    (0, _classCallCheck3.default)(this, Home);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this));

    _this.state = {
      title: 'Home',
      desc: '',
      url: _config2.default.domain
    };
    return _this;
  }

  //


  (0, _createClass3.default)(Home, [{
    key: 'render',
    value: function render() {
      var foeLogo = require('../../../static/images/img-foe-logo.png');
      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');
      var orangutanImg = require('../../../static/images/young-orangutan.jpg');

      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _container2.default.helmet(this.state.title, this.state.desc, this.state.url),
        _react2.default.createElement(
          'section',
          { styleName: 'hero' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'hero__content' },
              _react2.default.createElement(
                'h1',
                { styleName: 'hero__headline' },
                'We have the power to cut our financial ties to deforestation'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'hero__search-subhead' },
                'Check your mutual funds for deforestation-risk investments'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'hero__search-wrap' },
                _react2.default.createElement(_components.AutocompleteSearch, null)
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'hero__btn-subhead' },
                'Find sustainable, deforestation-free mutual funds and ETFs'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'hero__btn-wrap' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.clean,
                    bigbutton: true,
                    title: 'Top-scoring funds'
                  },
                  'Top-scoring funds',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'banner-logos-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-logos-copy' },
                  'A project of'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-logos' },
                  _react2.default.createElement('img', {
                    src: aysLogo,
                    alt: 'As You Sow',
                    styleName: 'banner-logo-ays'
                  }),
                  _react2.default.createElement(
                    _components.SrOnly,
                    null,
                    'As You Sow'
                  ),
                  _react2.default.createElement('img', {
                    src: foeLogo,
                    alt: 'Friends of the Earth',
                    styleName: 'banner-logo-foe'
                  }),
                  _react2.default.createElement(
                    _components.SrOnly,
                    null,
                    'Friends of the Earth'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'section',
          { styleName: 'lede-section' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'media-react-player-wrap-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'media-react-player-wrap' },
                _react2.default.createElement(_reactPlayer2.default, {
                  url: 'https://vimeo.com/433644374',
                  volume: 0.5
                })
              )
            ),
            _react2.default.createElement(
              'h2',
              { styleName: 'lede-section__headline' },
              'Cut deforestation out of your portfolio'
            ),
            _react2.default.createElement('img', {
              src: orangutanImg,
              alt: 'Young orangutan',
              styleName: 'lede-section__image'
            }),
            _react2.default.createElement(
              'p',
              null,
              'Deforestation and degradation of vast swaths of land for commodities such as palm oil, pulp and paper, cattle, soy, timber, and rubber is responsible for almost one quarter of all global greenhouse gas emissions and for unprecedented species extinction.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Simultaneously, the occupation of vast areas of land for industrial plantation agriculture is a leading cause of violent land conflicts due to its frequent dispossession and displacement of local and indigenous communities.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Simply put, if we want to limit the catastrophic impacts of climate change, reduce our impact on the world\u2019s biodiversity, and respect the rights of indigenous peoples, ',
              _react2.default.createElement(
                'strong',
                null,
                'protecting the world\u2019s remaining forests is key.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Deforestation isn\u2019t just bad for the planet. Increasingly, it\u2019s risky business. Companies engaged in deforestation, land grabbing and human rights violations expose themselves and their shareholders to significant financial risks from stalled business operations, reputational damage, and legal liabilities.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Deforestation Free Funds'
              ),
              ' is a search platform that informs and empowers everyday people, consumers, and investors to make decisions aligned with their values. It lets you see if your savings are invested in companies and sectors driving deforestation, shows you how to take action to get fund managers to implement more sustainable investment policies, and helps you find investment options that support an environmentally-friendly future.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'lede-section__btn-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'lede-section__btn' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.clean,
                    roundbutton: true,
                    title: 'Fund database'
                  },
                  'Fund database',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lede-section__btn' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.toolkit,
                    roundbutton: true,
                    title: 'Action toolkit'
                  },
                  'Action toolkit',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_components.InlineSignup, null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null)
          )
        ),
        _react2.default.createElement(_components.Works, null),
        _react2.default.createElement(
          'section',
          { styleName: 'sectors-section' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h2',
              { styleName: 'sectors-section__headline' },
              'Supply chains driving forest loss'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'sectors-section__text' },
              'Global deforestation is heavily driven by demand for agricultural commodities. Vast areas of tropical rainforest are destroyed for ',
              _react2.default.createElement(
                'strong',
                null,
                'palm oil'
              ),
              ', ',
              _react2.default.createElement(
                'strong',
                null,
                'cattle'
              ),
              ', ',
              _react2.default.createElement(
                'strong',
                null,
                'soy'
              ),
              ', ',
              _react2.default.createElement(
                'strong',
                null,
                'rubber'
              ),
              ', ',
              _react2.default.createElement(
                'strong',
                null,
                'timber'
              ),
              ', and ',
              _react2.default.createElement(
                'strong',
                null,
                'paper/pulp'
              ),
              '. Many global brands have pledged to reduce deforestation risk, but progress remains slow.'
            ),
            _react2.default.createElement(_components.DeforestationRiskSectorIconRow, null),
            _react2.default.createElement(
              'div',
              { styleName: 'sectors-section__btn' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.companies,
                  roundbutton: true,
                  title: 'See companies'
                },
                'See companies',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        ),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement(_components.InlineDonate, null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null)
        )
      );
    }
  }]);
  return Home;
}(_react.Component)) || _class);
exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 1335
// module chunks = 0